<div class="container-fluid theme-wrapper">
  <div class="container creole-banner text-right" [style.backgroundImage]="'url(' + newcreolebannerbgImageUrl + ')'">
    <div>
      <img [src]="creoletextImageUrl" class="creole-text" alt="creole" loading="lazy" decoding="async" />
    </div>
    <button class="btn btn-custom creole-button" (click)="btnClick()">
      {{ 'Dive into our Creole Culture' | translate }}
      <span class="svgicon">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 16 16">
          <!-- White Circle -->
          <circle cx="8" cy="8" r="8" fill="white" />

          <!-- SAME ARROW, just slightly thinner stroke -->
          <path
            d="M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
            fill="red"
            stroke="red"
            stroke-width="0.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>
  </div>
</div>
